import { listen, sendLocal } from "../channels";
import { partnerIdRequestMessage, isPartnerIdMessage } from "../messages/partnerId";
import { isData } from "../message";
export var getPartnerId = function getPartnerId() {
  return new Promise(function (resolve, reject) {
    var timeOut = setTimeout(function () {
      return reject("".concat(getPartnerId.name, " timed out"));
    }, 10 * 1000);
    var unsub = listen(function (message) {
      if (isData(message)) {
        unsub();
        clearTimeout(timeOut);
        resolve(message.payload);
      }
    }, isPartnerIdMessage);
    sendLocal(partnerIdRequestMessage());
  });
};